module.exports = __webpack_public_path__ + "img/poulet_pois_top.8993ef40.jpg";